import { render, staticRenderFns } from "./ConfirmacaoReprocessamentoModal.vue?vue&type=template&id=0d5041a2&scoped=true&"
import script from "./ConfirmacaoReprocessamentoModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmacaoReprocessamentoModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmacaoReprocessamentoModal.vue?vue&type=style&index=0&id=0d5041a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5041a2",
  null
  
)

export default component.exports